export const findPreferredSkuObj = (availability, preferredSizes, skus, includeUnavailableSize = false) => {
  if (Array.isArray(preferredSizes) && preferredSizes.length > 0) {
    const preferredAvailableSku =
      availability.find(o => {
        const isSkuAvailable = includeUnavailableSize ? true : o?.availableCount > 0;
        const isUserPreferredSize = o?.canonicalSizes.some(item => preferredSizes.includes(item));

        return isSkuAvailable && isUserPreferredSize;
      })?.sku ?? null;
    return preferredAvailableSku ? skus?.find(o => o?.sku === preferredAvailableSku) : null;
  }

  return null;
};
